export default function initVideosBlock() {
    document.addEventListener('DOMContentLoaded', () => {
        Videos.init();
    });

    let Videos = {
        init: () => {
            Videos.assignHandlers();
        },
        assignHandlers: () => {
            Videos.handlePlayButton();
        },
        handlePlayButton: () => {
            const playBtns = document.querySelectorAll('.video-block__play-button a');

            playBtns.forEach((playBtn) => {
                const container = playBtn.closest('.video-block');
                if (!container) return;

                const videoFrame = container.querySelector('iframe');
                if (!videoFrame) return;

                playBtn.addEventListener('click', (e) => {
                    e.preventDefault();

                    const thumb = container.querySelector('.video-block__thumbnail-wrapper');
                    if (thumb) thumb.style.display = 'none';
                    const playWrapper = playBtn.closest('.video-block__play-button');
                    if (playWrapper) {
                        playWrapper.classList.add('is-hidden');
                    }

                    if (!videoFrame.src.includes('autoplay=1')) {
                        videoFrame.src += (videoFrame.src.includes('?') ? '&' : '?') + 'autoplay=1';
                    }
                });
            });
        }
    };
}